// extracted by mini-css-extract-plugin
export default {"onBoardingStages":"styles_onBoardingStages__V6QSt","client":"styles_client__-uTlQ","onBoardingProgress":"styles_onBoardingProgress__zkxKa"};